import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { http } from "@next-core/http";
/**
 * @description 获取菜单信息
 * @endpoint GET /api/v1/micro-app/menus/:menuId
 */
export var InstalledMicroAppApi_getMenusInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (menuId, params, options) {
    return (/**! @contract easyops.api.micro_app.installed_micro_app.GetMenusInfo@1.0.0 */(yield http.get("api/gateway/micro_app.installed_micro_app.GetMenusInfo/api/v1/micro-app/menus/".concat(menuId), _objectSpread(_objectSpread({}, options), {}, {
        params
      }))).data
    );
  });
  return function InstalledMicroAppApi_getMenusInfo(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=getMenusInfo.js.map